module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addRefIdText":"No reference id present","newMessageIndicator":"NEW","awaitingApproval":"Awaiting"},"ja":{"addRefIdText":"管理IDが追加されていない","newMessageIndicator":"新着","awaitingApproval":"認証中"}}')
  delete Component.options._Ctor
}
